import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { moneyize } from '../../../../onestep-library/TextPresenters'
import { cancelRecurringCharge } from './actions'

function RecurringChargeListing(props){
  const dispatch = useDispatch()
  const { id, name, amount, payment_source, is_cancelled, first_due_date, next_due_date_that_hasnt_been_issued, interval, interval_count, ends_at, occurrences, email } = props
  const [ confirmCancel, setConfirmCancel ] = useState(false)

  function handleOpenEditForm(){
    dispatch({type: 'LOAD_EDIT_RECURRING_CHARGE', payload: props })
  }

  function handleCancel(){
    if (!confirmCancel){
      setConfirmCancel(true)
      setTimeout(()=>{setConfirmCancel(false)},3000)
    } else {
      dispatch(cancelRecurringCharge(id))
      setConfirmCancel(false)
    }
  }

  return(
    <tr className='hoverable'>
      <td className="cursor-pointer" onClick={handleOpenEditForm}>{next_due_date_that_hasnt_been_issued && moment(next_due_date_that_hasnt_been_issued).format("MMMM DD, YYYY")}</td>
      <td className="cursor-pointer" onClick={handleOpenEditForm}><div className={`${is_cancelled ? 'text-muted':'text-primary'} cursor-pointer`} onClick={handleOpenEditForm}>{name}</div></td>
      <td className="cursor-pointer" onClick={handleOpenEditForm}>{moneyize(amount)}</td>
      <td className="cursor-pointer" onClick={handleOpenEditForm}>{moment(first_due_date).format("MMMM DD, YYYY")}</td>
      <td className="cursor-pointer" onClick={handleOpenEditForm}>Every {interval_count} {interval}</td>
      <td className="cursor-pointer" onClick={handleOpenEditForm}>
        {ends_at && moment(ends_at).format("MMMM DD, YYYY")}
        {occurrences && `After occurring ${occurrences} time(s).`}
        {!ends_at && !occurrences && 'Never'}
      </td>
      <td className="cursor-pointer" onClick={handleOpenEditForm}>
        <div>{payment_source.payment_method == 'invoice' ? 'Invoice' : payment_source.name}</div>
        <small className={`${!is_cancelled && 'text-secondary'} d-block`}>{email}</small>
      </td>
      <td className={`${is_cancelled ? 'text-muted':'text-primary'}`}>
        {
          is_cancelled ? 
          <div className="text-muted p-3">
            CANCELLED
          </div> :
          <div>
            {
              confirmCancel ?
              <button 
                style={{width: '96px'}} 
                onClick={handleCancel} 
                className="btn btn-sm btn-danger ml-3 p-2 d-flex justify-content-center align-items-center">
                CONFIRM?
              </button> :
              <button 
                style={{width: '96px'}} 
                onClick={handleCancel} 
                className="btn btn-sm btn-warning ml-3 p-2 d-flex justify-content-center align-items-center">
                STOP
              </button>
            }
          </div>
        }
      </td>
    </tr>
  )
}

export default RecurringChargeListing